import React from "react";

import API from "@beardeddevops/react.api";
import Framework from '@beardeddevops/react.framework';
import Types from "constants/Types";
import TransactionCollection from "components/TransactionCollection";
import TransactionType from "../../constants/TransactionTypes";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

export default class Dispositions extends TransactionCollection {
	constructor(props) {
		let model = new API.BuildClass(Types.Transactions._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_DISPOSITIONS';
		this.model.set = TransactionType.Disposition;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if(this.props.setTotalCount && (this.state.totalCount !== prevState.totalCount) && typeof this.state.totalCount !== 'undefined' && ((this.state.startDate !== null || this.state.startDate !== "") || (this.state.endDate !== "" || this.start.endDate !== null))) {
			this.props.grabDateFilter(this.model.filter.date);
			this.props.setTotalCount(this.state.totalCount);
		}
		if(this.props.setTotalCount && (this.state.totalCount !== prevState.totalCount) && typeof this.state.totalCount !== 'undefined' && ((this.state.startDate === null || this.state.startDate === "")  && (this.state.endDate === "" || this.state.endDate === null))) {
			this.props.setTotalCount(0);
		}
	}
	
	render() {
		const {loading} = this.state;
		return (
			<Card>
				<CardContent>
					{super.render('Dispositions', 'dispositions', "Buyer", [
						{
							Header: 'Notes',
							accessor: 'notes',
							show: !!this.state['column_notes'],
							toggle: 'column_notes'
						}
					])}

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}